import { useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SurveySendStore } from 'widgets/SurveySend/store/SurveySendStore'

export const useSurveySendStore = () => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new SurveySendStore(entities))

  useEffect(() => {
    store.checkActivity()
  }, [])

  return store
}
